
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCorperateMessageRecieptGrid extends Serenity.EntityGrid<PsCorperateMessageRecieptRow, any> {
        protected getColumnsKey() { return PsCorperateMessageRecieptColumns.columnsKey; }
        protected getDialogType() { return PsCorperateMessageRecieptDialog; }
        protected getIdProperty() { return PsCorperateMessageRecieptRow.idProperty; }
        protected getInsertPermission() { return PsCorperateMessageRecieptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCorperateMessageRecieptRow.localTextPrefix; }
        protected getService() { return PsCorperateMessageRecieptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}